export default __webpack_public_path__ + "media/images/map/car/16x16-44cca4a618a09539d86ea90f74fc50db.png";